<template>
  <div class="modal is-active">
    <div
      class="modal-background"
      @click.stop="$emit('close-section-data-popup')"
    ></div>
    <div class="modal-content section-data" ref="view-container">
      <div class="section-criteria">
        <p>Theme: {{ section.id }}</p>
        <p class="section-comments">{{ section.comments || null }}</p>
        <ul
          v-for="grade in Object.keys(section.criteria).filter(
            (c) => section.criteria[c].length
          )"
          :key="grade"
        >
          <span>
            {{ grade }}
          </span>
          <li v-for="(criteria, index) in section.criteria[grade]" :key="index">
            {{ criteria }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModeratedSectionPopup',
  props: ['section'],
  data() {
    return {
      showAuditData: false,
      names: {
        not_applicable: {
          text: 'Not Applicable',
          color: '#D4D6E4'
        },
        outstanding: {
          text: 'Outstanding',
          color: '#00B9C1'
        },
        good: {
          text: 'Good',
          color: '#49E5A6'
        },
        requires_improvement: {
          text: 'Requires Improvement',
          color: '#FFCB4B'
        },
        inadequate: {
          text: 'Inadequate',
          color: '#E76D93'
        },
        essential: {
          text: 'Clearly Includes',
          color: '#00B9C1'
        }
      },
      selectedCriteria: null
    }
  },
  methods: {
    viewSectionCriteria(section) {
      this.$refs['view-container'].style.width = '850px'
      this.selectedCriteria = section
      this.selectedCriteria.totalCriteria = Object.keys(
        section.criteria
      ).reduce(
        (accum, current) => (accum += section.criteria[current].length),
        0
      )
    },
    color(grade) {
      const style = {
        color: 'white',
        background: null
      }
      style.background =
        grade.determination &&
        (grade.id !== 'additional-components' || grade.id !== 'next-steps')
          ? this.names[grade.determination].color
          : '#00B9C1'
      return style
    }
  },
  mounted() {
    this.selectedCriteria = null
    this.$refs['view-container'].style.width = '400px'
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/modal.scss';

.modal-content.section-data {
  width: 400px;
  display: grid;
  grid-template-areas:
    'title title'
    'grades criteria';
  column-gap: 0.5rem;
  transition: all 300ms;
}

.modal-content.section-data > .title {
  grid-area: title;
  margin-bottom: 1rem;
}

.sections-container {
  grid-area: grades;
  padding: 0.5rem;
}
.section-criteria {
  grid-area: criteria;
  padding: 0.5rem;
  ul {
    list-style: none;
    padding-inline-start: 1rem;
    span {
      font-size: 1rem;
      text-decoration: underline;
    }
    li {
      font-size: 0.875rem;
      padding: 0.5rem 0;
    }
  }
}

.section-criteria > p {
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
}

.section-comments {
  font-size: 0.9rem !important;
  text-align: left;
  padding-top: 1rem;
  font-size: 400;
  font-style: italic;
}

.section-comments::before {
  content: 'Comments: ';
  font-style: normal;
}

.section-item {
  width: 100%;
  display: grid;
  grid-template-columns: 110px 1fr;
  column-gap: 0.5rem;
  div {
    padding: 0.25rem;
    display: flex;
    align-items: center;
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      min-width: 36px;
      padding: 6px 8px;
      border-radius: 30px;
      text-transform: uppercase;
      background: #f2f2f2;
    }
  }
  .section-id {
    justify-self: center;
  }
  .section-grade {
    padding-left: 1rem;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
